import { FC } from "react"
import FirstLoginFlowLayout from "./layout"
import { Formik } from "formik"
import * as Yup from 'yup'
import { postalCodeTrans, requiredTrans } from "../forms/formTranslations"
import { FirstLoginFlowGoalType } from "./types"
import { GoalSelection } from "./GoalSelection"
import { ConnectToOrganization } from "./ConnectToOrganization"
import { OrganizationConnectSearch } from "./OrganizationConnectSearch"
import { OrganizationConnectResults } from "./OrganizationConnectResults"
import { maxLength } from "../forms/formTranslations"
import { OrganizationConnectRequestSent } from "./OrganizationConnectRequestSent"
import { CreateNewOrganization } from "./CreateNewOrganization"
import { useGoalOption } from "./useGoalOption"
import { OrganizationConnectNoResults } from "./OrganizationConnectNoResults"
import { OrganizationConnectTooManyResults } from "./OrganizationConnectTooManyResults"
import { RootStateOrAny, useSelector } from "react-redux"
import { OrganizationCreated } from "./OrganizationCreated"

export type FirstLoginFlowFormikProps = {
  goal: FirstLoginFlowGoalType
  goalCompleted: boolean
  displayOrganizationConnectDialog: boolean
  displayCreateNewOrganizationDialog: boolean
  displayOrganizationCreatedWindow: boolean
  search: string
  results: any
  resultsError: string
  selectedOrganizationId: string | null
  joinOrganizationIds: string[] | null
  jobTitle: string
  isRequestSent: boolean,
}

const FirstLoginFlow: FC<{initialValues?: Partial<FirstLoginFlowFormikProps>}> = ({ initialValues}) => {
  const { goalOptions } = useGoalOption()

  const user  = useSelector<RootStateOrAny>(state => state.user)

  return (<Formik
    initialValues={{
      goal: '' as FirstLoginFlowGoalType,
      goalCompleted: false,
      displayOrganizationConnectDialog: false,
      displayCreateNewOrganizationDialog: false,
      displayOrganizationCreatedWindow: false,
      search: '',
      results: null,
      resultsError: '',
      joinOrganizationIds: null,
      selectedOrganizationId: null,
      jobTitle: '',
      isRequestSent: false,
      ...initialValues
    } as FirstLoginFlowFormikProps}
    onSubmit={(values) => {
      console.log(values)
    }}
    validationSchema={
      Yup.object().shape({
        // @ts-ignore
        goal: Yup.string().required(requiredTrans),
        // @ts-ignore
        search: Yup.string().required(requiredTrans),
        // @ts-ignore
        jobTitle: Yup.string().required(requiredTrans).max(80, maxLength({ max: 80 })),
      })
    }
  >
    {(formik) => {
      const {
        goalCompleted, displayOrganizationConnectDialog, results, resultsError, isRequestSent,
        displayCreateNewOrganizationDialog, displayOrganizationCreatedWindow
      } = formik.values

      return (
        <FirstLoginFlowLayout>
          {!goalCompleted && <GoalSelection goalOptions={goalOptions}/>}
          {goalCompleted && !displayOrganizationConnectDialog && !displayCreateNewOrganizationDialog && !displayOrganizationCreatedWindow 
            && <ConnectToOrganization 
              goalOptions={goalOptions.filter(option => {
                return option.value === 'Apply for funding' || option.value === 'Fill grantee report' || option.value === 'Complete the organizational compass'
              })}
            />
          }
          {displayOrganizationConnectDialog && !results && !isRequestSent && !resultsError && 
            <OrganizationConnectSearch displayBackBtn={true}/>
          }
          {displayOrganizationConnectDialog && results && <OrganizationConnectResults/>}
          {resultsError && <>
            {resultsError === 'TOO_MANY_RECORDS_FOUND_ERROR' && <OrganizationConnectTooManyResults/>}
            {resultsError === 'NO_ORGANIZATION_FOUND_ERROR' && <OrganizationConnectNoResults/>}
          </>}
          {isRequestSent && <OrganizationConnectRequestSent/>}
          {displayCreateNewOrganizationDialog && <CreateNewOrganization/>}
          {displayOrganizationCreatedWindow && <OrganizationCreated/>}
        </FirstLoginFlowLayout>
      )
    }}
  </Formik>)
}

export default FirstLoginFlow